import "styles/pages/page-service.scss";
import React, { useState } from "react";

import Layout from "components/Layout";
import ScrollTile from "components/ScrollTile/ScrollTile";
import Seo from "components/Seo";
import SubpageHeader from "components/SubpageHeader/SubpageHeader";
import TeamPersonTile from "components/TeamPersonTile/TeamPersonTile";
import VerticalScrollMenu from "components/VerticalScrollMenu/VerticalScrollMenu";
import SectionHeader from "components/SectionHeader/SectionHeader";
import ContactForm from "../components/ContactForm/ContactForm";

const ServicePage = ({ pageContext }) => {
  const [recipient, setRecipient] = useState("");
  const pageContent = pageContext.pageContent;
  const seo = pageContext.seo;
  const team = pageContext.pageContent.serviceTeam;
  const onReset = () => {
    setRecipient("");
  };
  return (
    <Layout>
      <Seo title={seo.title} description={seo.metaDesc} />
      <SubpageHeader
        title={pageContent.mainTitle}
        subtitle={pageContent.subtitle}
        location={pageContext.title}
        crumbFirstLabel="serwis części i akcesoria"
      />
      <section className="service-about">
        <div className="container">
          <div
            className="service-about__text"
            dangerouslySetInnerHTML={{ __html: pageContent.desc }}
          />
          <div className="row justify-content-center">
            <div className="col-xl-4 col-sm-6">
              <ScrollTile
                title="Naprawy gwarancyjne <br />i pogwarancyjne"
                icon={require("assets/icons/varianty-repairs.svg").default}
                anchor="serwis-1"
                buttonText="Czytaj więcej"
                shadow={false}
              />
            </div>
            <div className="col-xl-4 col-sm-6">
              <ScrollTile
                title="Kompleksowe naprawy <br /> powypadkowe"
                icon={require("assets/icons/complex-repair.svg").default}
                anchor="serwis-2"
                buttonText="Czytaj więcej"
                shadow={false}
              />
            </div>
            <div className="col-xl-4 col-sm-6">
              <ScrollTile
                title="Doposażenie pojazdów <br /> i przyczep kempingowych"
                icon={require("assets/icons/service-equipment.svg").default}
                anchor="serwis-3"
                buttonText="Czytaj więcej"
                shadow={false}
              />
            </div>
            <div className="col-xl-4 col-sm-6">
              <ScrollTile
                title="Naprawy <br /> urządzeń AGD i RTV"
                icon={require("assets/icons/service-rtv-agd.svg").default}
                anchor="serwis-4"
                buttonText="Czytaj więcej"
                shadow={false}
              />
            </div>
            <div className="col-xl-4 col-sm-6">
              <ScrollTile
                title="Przeglądy szczelności kamperów i przyczep"
                icon={require("assets/icons/service-cloud.svg").default}
                anchor="serwis-5"
                buttonText="Czytaj więcej"
                shadow={false}
              />
            </div>
            <div className="col-xl-4 col-sm-6">
              <ScrollTile
                title="Montaż zawieszeń, pneumatyki i podpór hydraulicznych"
                icon={require("assets/icons/service-suspensions.svg").default}
                anchor="serwis-6"
                buttonText="Czytaj więcej"
                shadow={false}
              />
            </div>
            <div className="col-xl-4 col-sm-6">
              <ScrollTile
                title="Przeglądy okresowe pojazdów i urządzeń"
                icon={require("assets/icons/service-periodic.svg").default}
                anchor="serwis-7"
                buttonText="Czytaj więcej"
                shadow={false}
              />
            </div>
            <div className="col-xl-4 col-sm-6">
              <ScrollTile
                title="Oryginalne części i zamienne"
                icon={
                  require("assets/icons/service-original-parts.svg").default
                }
                anchor="serwis-8"
                buttonText="Czytaj więcej"
                shadow={false}
              />
            </div>
            <div className="col-xl-4 col-sm-6">
              <ScrollTile
                title="Skontaktuj się z nami
                i umów wizytę serwisową!"
                icon={require("assets/icons/team-support.svg").default}
                anchor="kontakt"
                buttonText="Skontaktuj się z serwisem"
                shadow={false}
                contact={true}
              />
            </div>
          </div>
        </div>
      </section>
      <section className="service-content">
        <div className="container">
          <div className="row">
            <div className="col-md-3">
              <VerticalScrollMenu
                tabs={[
                  {
                    label: "Naprawy gwarancyjne i pogwarancyjne",
                    anchor: "serwis-1",
                  },
                  {
                    label: "Kompleksowe naprawy powypadkowe",
                    anchor: "serwis-2",
                  },
                  {
                    label: "Doposażenie pojazdów i przyczep kempingowych",
                    anchor: "serwis-3",
                  },
                  {
                    label: "Naprawy urządzeń RTV i AGD",
                    anchor: "serwis-4",
                  },
                  {
                    label: "Przeglądy szczelności  kamperów i przyczep",
                    anchor: "serwis-5",
                  },
                  {
                    label: "Montaż zawieszeń, pneumatyki i podpór",
                    anchor: "serwis-6",
                  },
                  {
                    label: "Przeglądy okresowe pojazdów i urządzeń ",
                    anchor: "serwis-7",
                  },
                  {
                    label: "Oryginalne części zamienne",
                    anchor: "serwis-8",
                  },
                  { label: "Kontakt z serwisem", anchor: "kontakt" },
                ]}
              />
            </div>
            <div className="col-md-9">
              {pageContent.content?.map((node, index) => {
                return (
                  <>
                    <span className="anchor" id={`serwis-${index + 1}`} />
                    <div className="service-content__item" key={index}>
                      <h2 className="service-content__item-title">
                        {node.title}
                      </h2>
                      <div
                        className="service-content__item-content"
                        dangerouslySetInnerHTML={{ __html: node.content }}
                      />
                    </div>
                  </>
                );
              })}
              <div className="service-content__logos-container">
                <h2 className="service-content__logos-title">
                  JESTEŚMY OFICJALNYM DYSTRYBUTOREM CZĘŚCI
                </h2>
                <div className="service-content__logos">
                  {pageContent.logos?.map((node, index) => {
                    return (
                      <div className="service-content__logo-wrapper">
                        <img
                          src={node.sourceUrl}
                          alt=""
                          className="img-fluid service-content__single-logo"
                          key={index}
                        />
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <span className="anchor" id="kontakt"></span>
      <section className="service-team">
        <div className="container">
          <SectionHeader
            title="Skontaktuj się z serwisem Elcamp RV!"
            subtitle="NASZ ZESPÓŁ"
            reversed={true}
          />
          <div className="row justify-content-center">
            {team?.map((person, index) => {
              return (
                <div className="col-xl-3 col-md-4 col-sm-6" key={index}>
                  <TeamPersonTile
                    name={person.singleTeam.fullname}
                    jobName={person.singleTeam.jobname}
                    avatar={person.singleTeam.avatar?.sourceUrl}
                    phone={person.singleTeam.phone}
                    email={person.singleTeam.email}
                    onClick={(e) => setRecipient(person.singleTeam.email)}
                  />
                </div>
              );
            })}
          </div>
        </div>
      </section>
      <span className="anchor" id="formularz"></span>
      <section className="service-contact">
        <ContactForm
          subject="SERWIS"
          selectedEmail={recipient}
          onReset={onReset}
        />
      </section>
    </Layout>
  );
};

export default ServicePage;
